// import style css
import "../scss/style.scss";

/* ============= LANGUAGE ============= */
const translations = {
    tr: {
        pageTitle: "Kekova'yı Keşfedin - Cengiz Tülü ile Özel Tekne Turları",
        languageLabel: "Dil seçimi",
        heroSubtitle: "Size özel Kekova tekne turları",
        heroTitle: "Güzel <span class=\"kekova-word\"><span class=\"kekova-highlight\">Kekova</span><span class=\"kekova-suffix\">'yı</span></span> <br /><b>Cengiz Kaptan ile keşfedin</b>",
        homeImageAlt: "Kekova kıyılarında Cengiz Kaptan'ın teknesi",
        mapLabel: "Kekova konumunu haritada aç",
        heroCardTitle: "Cengiz Kaptan - Kekova'daki dostunuz",
        moreButton: "Daha fazla",
        captainCardAlt: "Kekova'da Cengiz Kaptan",
        discoverTitle: "Kekova'nın en güzel<br />yerlerini keşfedin",
        kalekoyAlt: "Kaleköy ve tarihi kalesi",
        kalekoyDescription: "Kekova'nın tarihi kalesi",
        sunkenCityTitle: "Batık Şehir",
        sunkenCityDescription: "Antik bir uygarlığın izleri",
        sunkenCityAlt: "Kekova Batık Şehir kalıntıları",
        ucagizDescription: "Yolculuğunuzun başlangıç noktası",
        ucagizAlt: "Üçağız'ın havadan görünümü",
        bayTitle: "Eşsiz koylardan biri",
        bayDescription: "Sıradaki siz olun",
        bayAlt: "Kekova'nın berrak ve sakin koylarından biri",
        bookingTitle: "Denize açılmaya hazır mısınız?<br />Gelin, turunuzu birlikte planlayalım",
        bookingDescription: "Rezervasyon için WhatsApp'tan mesaj göndermeniz veya bizi aramanız yeterli. En kısa sürede size dönüş yaparak sizin, aileniz ve arkadaşlarınız için size özel en mükemmel turu birlikte planlayalım.",
        phoneLabel: "Telefon",
        bookingImageOneAlt: "Kekova Batık Şehir'de tarihi kalıntılar",
        bookingImageTwoAlt: "Cengiz Kaptan'ın ahşap gezi teknesi",
        foodTitle: "Lezzetli<br />Türk mutfağı",
        foodDescription: "Denizde geçen güzel bir gün, lezzetli yemekleri hak eder. Menümüzde Türk ve Akdeniz mutfağının en sevilen tatları var: taptaze balıklar, özenle pişirilmiş ızgara etler ve zengin vejetaryen seçenekler. Mangalımızın yıldızı ızgarada pişirilen tap taze balıklar; ona nefis tavuk çeşitleri eşlik ediyor. Gün boyunca soğuk içecekler ve taze demlenmiş Türk çayı da ikramımız.",
        fishMealAlt: "Teknede servis edilen taze balık yemeği",
        barbecueFishAlt: "Mangalda pişen taze balık",
        foodSpreadAlt: "Türk ve Akdeniz yemeklerinden oluşan sofra",
        captainTitle: "Kaptanınızla tanışın",
        captainDescription: "Kekova kıyısındaki küçük balıkçı köyü Üçağız'da doğup büyüdüm; deniz ilk günden beri hayatımın merkezinde. Saklı koyları, en güzel balık noktalarını ve çoğu kişinin bilmediği sakin demir yerlerini avucumun içi gibi bilirim. Her sabah yola çıkmadan önce annemle yemekleri taze taze hazırlarız; bu yüzden teknede tattığınız her şey gerçekten ev yapımıdır. Dalmayı, balık tutmayı ve bu eşsiz coğrafyanın güzelliklerini paylaşmayı seviyorum. Her misafirimi ailemden biri gibi görürüm; benim için en önemlisi sizin güzel bir deneyim yaşamanızdır.",
        captainPortraitAlt: "Kekovalı Cengiz Kaptan",
        boatExteriorAlt: "Kekova tur teknemiz",
        boatAtSeaAlt: "Teknemiz Kekova kıyılarında",
        boatTitle: "Eviniz kadar rahat<br />bir tekne",
        boatDescription: "14 metrelik teknemiz Kekova için ideal boyutta: rahat etmeniz için yeterince geniş, büyük teknelerin ulaşamadığı yerlere girecek kadar çevik. Bu kıyılara özgü geleneksel ahşap tarzda inşa edilen teknem, yıllardır ikinci evim. Her sabah tertemiz, bakımlı ve denize hazır olmasına özen gösteriyorum. Teknede tuvalet, duş, güneşlenme minderleri ve gün boyu ihtiyaç duyacağınız her şey bulunuyor. Her şeyden önemlisi, güvenlik daima önceliğimiz. Tekneye adım attığınız anda emin ellerde olduğunuzu bilerek rahatlayabilirsiniz.",
        boatInteriorAlt: "Teknenin iç bölümü",
        boatSeatingAlt: "Teknenin geniş oturma alanı",
        boatRelaxationAlt: "Teknenin dinlenme alanı",
        boatDeckAlt: "Teknenin ahşap güvertesi",
        copyright: "© 2026 Cengiz Tülü. Tüm hakları saklıdır.",
        terms: "Şartlar ve Koşullar",
        privacy: "Gizlilik Politikası",
        whatsappCta: "WhatsApp'tan rezervasyon",
        whatsappCtaLabel: "WhatsApp'tan rezervasyon için yazın",
        whatsappMessage: "Merhaba Cengiz Kaptan, Kekova özel tekne turu hakkında bilgi almak ve rezervasyon yapmak istiyorum.",
        scrollTopLabel: "Sayfanın başına dön"
    },
    en: {
        pageTitle: "Explore Kekova - Private Boat Tours with Cengiz Tülü",
        languageLabel: "Language selection",
        heroSubtitle: "Discover your personal Kekova experience",
        heroTitle: "Discover beautiful <span class=\"kekova-highlight\">Kekova</span> <br /><b>with Captain Cengiz</b>",
        homeImageAlt: "Captain Cengiz's boat off the coast of Kekova",
        mapLabel: "Open Kekova's location on the map",
        heroCardTitle: "Captain Cengiz - Your friend in Kekova",
        moreButton: "Learn more",
        captainCardAlt: "Captain Cengiz in Kekova",
        discoverTitle: "Discover Kekova's most<br />beautiful places",
        kalekoyAlt: "Kaleköy and its historic castle",
        kalekoyDescription: "Kekova's historic castle",
        sunkenCityTitle: "Sunken City",
        sunkenCityDescription: "Traces of an ancient civilization",
        sunkenCityAlt: "The ruins of Kekova's Sunken City",
        ucagizDescription: "The starting point of your journey",
        ucagizAlt: "Aerial view of Üçağız",
        bayTitle: "One of many unique bays",
        bayDescription: "You could be next →",
        bayAlt: "One of Kekova's clear, peaceful bays",
        bookingTitle: "Ready to set sail?<br />Let's plan your trip together",
        bookingDescription: "Booking is easy: send us a message on WhatsApp or give us a call. We'll get back to you as soon as possible and create the perfect tour for you, your family, and your friends.",
        phoneLabel: "Phone",
        bookingImageOneAlt: "Ancient ruins in Kekova's Sunken City",
        bookingImageTwoAlt: "Captain Cengiz's traditional wooden tour boat",
        foodTitle: "Delicious<br />Turkish cuisine",
        foodDescription: "A wonderful day at sea deserves wonderful food. Our menu brings together favorite flavors from Turkish and Mediterranean cuisine: freshly caught fish, carefully grilled meats, and generous vegetarian options. Fresh fish is the star of our barbecue, accompanied by delicious grilled chicken. Cold refreshments and freshly brewed Turkish tea are also served throughout the day.",
        fishMealAlt: "Fresh fish meal served on the boat",
        barbecueFishAlt: "Fresh fish cooking on the barbecue",
        foodSpreadAlt: "A spread of Turkish and Mediterranean dishes",
        captainTitle: "Meet your captain",
        captainDescription: "I was born and raised in Üçağız, a small fishing village on the shores of Kekova, and the sea has been at the heart of my life from day one. I know these waters like the back of my hand—from hidden bays and the best fishing spots to quiet anchorages that most people never find. Every morning, my mother and I prepare the food fresh before we set off, so everything you enjoy on board is truly homemade. I love diving, fishing, and sharing the beauty of this remarkable place. I treat every guest like family, and giving you an unforgettable experience is what matters most to me.",
        captainPortraitAlt: "Captain Cengiz from Kekova",
        boatExteriorAlt: "Our Kekova tour boat",
        boatAtSeaAlt: "Our boat off the coast of Kekova",
        boatTitle: "A boat that feels<br />like home",
        boatDescription: "At 14 meters, our boat is the perfect size for Kekova: spacious enough for complete comfort and agile enough to reach places that larger boats cannot. Built in the traditional wooden style of these shores, she has been my second home for years. I make sure she is spotless, well maintained, and ready for the sea every morning. On board, you'll find a proper toilet, a shower, sunbeds, and everything you need for a full day out. Above all, safety always comes first. From the moment you step aboard, you can relax knowing you're in good hands.",
        boatInteriorAlt: "The boat's interior",
        boatSeatingAlt: "The boat's spacious seating area",
        boatRelaxationAlt: "The boat's relaxation area",
        boatDeckAlt: "The boat's wooden deck",
        copyright: "© 2026 Cengiz Tülü. All rights reserved.",
        terms: "Terms & Conditions",
        privacy: "Privacy Policy",
        whatsappCta: "Book on WhatsApp",
        whatsappCtaLabel: "Message us on WhatsApp to book",
        whatsappMessage: "Hello Captain Cengiz, I would like more information and want to book a private boat tour in Kekova.",
        scrollTopLabel: "Back to the top"
    }
}

const languageButtons = document.querySelectorAll('[data-language]')
const floatingWhatsapp = document.querySelector('.floating-whatsapp')
const heroSocialLinks = document.querySelectorAll('.home__social-link')

// Turkish is authored directly in the HTML. Capture it before applying a
// saved language so hot-reloaded HTML edits are not replaced by stale copy.
const syncTurkishCopyFromMarkup = () => {
    const copy = translations.tr
    copy.pageTitle = document.title

    document.querySelectorAll('[data-i18n]').forEach(element => {
        const value = element.textContent.trim()
        if (value) copy[element.dataset.i18n] = value
    })

    document.querySelectorAll('[data-i18n-html]').forEach(element => {
        const value = element.innerHTML.trim()
        if (value) copy[element.dataset.i18nHtml] = value
    })

    document.querySelectorAll('[data-i18n-alt]').forEach(element => {
        if (element.alt) copy[element.dataset.i18nAlt] = element.alt
    })

    document.querySelectorAll('[data-i18n-aria]').forEach(element => {
        const value = element.getAttribute('aria-label')
        if (value) copy[element.dataset.i18nAria] = value
    })
}

syncTurkishCopyFromMarkup()

const alignFloatingWhatsapp = () => {
    if (!floatingWhatsapp || heroSocialLinks.length < 2) return

    const instagramBounds = heroSocialLinks[0].getBoundingClientRect()
    const mapsBounds = heroSocialLinks[1].getBoundingClientRect()
    const isHorizontal = Math.abs(instagramBounds.top - mapsBounds.top) < 1

    if (isHorizontal) {
        const socialGap = mapsBounds.left - instagramBounds.right
        floatingWhatsapp.style.left = `${mapsBounds.right + socialGap}px`
    } else {
        floatingWhatsapp.style.left = `${instagramBounds.left}px`
    }
}

alignFloatingWhatsapp()
window.addEventListener('resize', alignFloatingWhatsapp)

if (floatingWhatsapp) {
    let hasPlayedScrollLift = false
    let isScrollLiftArmed = window.scrollY <= 2

    const playScrollLift = () => {
        if (hasPlayedScrollLift) return

        if (window.scrollY <= 2) {
            isScrollLiftArmed = true
            return
        }

        if (!isScrollLiftArmed) return

        hasPlayedScrollLift = true
        window.removeEventListener('scroll', playScrollLift)

        if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return

        floatingWhatsapp.classList.add('scroll-lift')
        floatingWhatsapp.addEventListener(
            'animationend',
            () => floatingWhatsapp.classList.remove('scroll-lift'),
            { once: true }
        )
    }

    window.addEventListener('scroll', playScrollLift, { passive: true })
}

const getSavedLanguage = () => {
    try {
        return localStorage.getItem('preferredLanguage')
    } catch (error) {
        return null
    }
}

const saveLanguage = language => {
    try {
        localStorage.setItem('preferredLanguage', language)
    } catch (error) {
        // The site still works when browser storage is unavailable.
    }
}

const applyLanguage = language => {
    const selectedLanguage = translations[language] ? language : 'tr'
    const copy = translations[selectedLanguage]

    document.documentElement.lang = selectedLanguage
    document.title = copy.pageTitle

    if (floatingWhatsapp) {
        floatingWhatsapp.href = `https://wa.me/905350444710?text=${encodeURIComponent(copy.whatsappMessage)}`
    }

    document.querySelectorAll('[data-i18n]').forEach(element => {
        const value = copy[element.dataset.i18n]
        if (value) element.textContent = value
    })

    document.querySelectorAll('[data-i18n-html]').forEach(element => {
        const value = copy[element.dataset.i18nHtml]
        if (value) element.innerHTML = value
    })

    document.querySelectorAll('[data-i18n-alt]').forEach(element => {
        const value = copy[element.dataset.i18nAlt]
        if (value) element.alt = value
    })

    document.querySelectorAll('[data-i18n-aria]').forEach(element => {
        const value = copy[element.dataset.i18nAria]
        if (value) element.setAttribute('aria-label', value)
    })

    languageButtons.forEach(button => {
        const isActive = button.dataset.language === selectedLanguage
        button.classList.toggle('is-active', isActive)
        button.setAttribute('aria-pressed', String(isActive))
    })

    saveLanguage(selectedLanguage)
}

languageButtons.forEach(button => {
    button.addEventListener('click', () => applyLanguage(button.dataset.language))
})

applyLanguage(getSavedLanguage() || 'tr')


/* ============= VIDEO ============= */
const video = document.getElementById('video-file'),
btn = document.getElementById('video-btn'),
btnIcon = document.getElementById('video-btn-icon')

const videoAction = () => {
    if(video.paused){
        video.play()

        btnIcon.classList.add('uil-pause')

        btnIcon.classList.remove('uil-play')

    }else{
        video.pause()

        btnIcon.classList.add('uil-play')
        btnIcon.classList.remove('uil-pause')

    }
}

if (video && btn && btnIcon) {
    btn.addEventListener('click', videoAction)

    const resetVideo = () => {
        btnIcon.classList.add('uil-play')
        btnIcon.classList.remove('uil-pause')
    }

    video.addEventListener('ended', resetVideo)
}

/* =============== SCROLL UP =============== */
const scroll = document.getElementById('scroll-up')

const showScrollBtn = () => {
    if(pageYOffset > 300){
        scroll.classList.add('show-scrollup')
    }else{
        scroll.classList.remove('show-scrollup')
    }
}

const scrollTop = () =>{
    document.body.scrollTop = 0;
    document.documentElement.scrollTop = 0;
}

if (scroll) {
    window.addEventListener('scroll', showScrollBtn)
    scroll.addEventListener('click', scrollTop)
}

/* =============== CONTACT BAR SWEEP ANIMATION =============== */
const contactBar = document.querySelector('.about__contact')

if (contactBar) {
    const observer = new IntersectionObserver(
        ([entry]) => {
            if (entry.isIntersecting) {
                contactBar.classList.add('in-view')
                observer.disconnect()
            }
        },
        { threshold: 0.6 }
    )
    observer.observe(contactBar)
}

